<div style="display: inline-block" class="uxDesignerTemplatePanel">
  <ng-container *ngIf="!model.renameMode">
    <div
      style="
        border-radius: 3px;
        background-color: white;
        display: inline-block;
        padding-top: 0px;
        height: var(--unity-input-height);
        margin-right: 4px;
      "
    >
      <!-- <label for="SelectTemplate">Select Template: </label> -->
      <div style="display: inline-block; width: 140px" class="margin-r-5">
        <ep-dropdown
          name="SelectTemplate"
          class="unity-form-group select"
          [codeValues]="settingListAsCodeSet"
          [(ngModel)]="model.Setting_ID"
          [addOptionIfMissing]="false"
          (ngModelChange)="settingSelected($event)"
          ngbTooltip="Select Template"
        ></ep-dropdown>
      </div>
      <div style="display: inline-block; vertical-align: top; padding-top: 5px">
        <button unity-button
          *ngIf="!noTemplateSelected"
          type="button"
          classes="icon-only icon-only-small"
          (click)="startRename('EDIT')"
          ngbTooltip="Edit Template Name"
        >
          <svg class="unity-icon unity-icon-pencil">
            <use xlink:href="#unity-icon-pencil"></use>
          </svg>
        </button>
        <button unity-button
          *ngIf="!noTemplateSelected"
          type="button"
          classes="icon-only icon-only-small"
          (click)="startRename('CLONE')"
          ngbTooltip="Clone Template"
        >
          <svg class="unity-icon unity-icon-copy">
            <use xlink:href="#unity-icon-copy"></use>
          </svg>
        </button>
        <button unity-button
          type="button"
          classes="icon-only icon-only-small"
          (click)="settingSelected('0')"
          ngbTooltip="New Template"
        >
          <svg class="unity-icon unity-icon-plus">
            <use xlink:href="#unity-icon-plus"></use>
          </svg>
        </button>
      </div>
    </div>
  </ng-container>
  <ng-container *ngIf="model.renameMode">
    <div
      style="
        border: 1px solid white;
        border-radius: 3px;
        background-color: white;
        display: inline-block;
        padding-top: 2px;
        height: var(--unity-input-height);
        margin-right: 4px;
      "
    >
      <input
        #templateName
        name="Title"
        class="margin-r-5"
        [(ngModel)]="model.New_Title"
        (ngModelChange)="pageOS.setDirty()"
        maxLength="80"
        placeholder="Enter Template Name"
        style="border: none"
      />
      <!-- overlay input with buttons    OR wrap input & buttons and drop borders -->

      <div style="display: inline-block; vertical-align: top; padding-top: 1px">
        <button unity-button
          [disabled]="model.New_Title == ''"
          type="button"
          classes="icon-only icon-only-large"
          (click)="endRename()"
          ngbTooltip="Update Name"
        >
          <svg class="unity-icon unity-icon-checkmark">
            <use xlink:href="#unity-icon-checkmark"></use>
          </svg>
        </button>
        <button unity-button type="button" classes="icon-only" (click)="cancelRename()" ngbTooltip="Cancel Rename">
          <svg class="unity-icon unity-icon-times icon-only-large">
            <use xlink:href="#unity-icon-times"></use>
          </svg>
        </button>
      </div>
    </div>
  </ng-container>
</div>
